export default {
    // --------Title--------
    selectSearchLocation: '选择搜索仓库',
    youCanSelectMultipleWarehouseLocationsToProceed: '可以选择多个仓库位置以继续',
    advancedFilters: '高级筛选',
    dataFilters: '筛选数据',
    multipleFiltersApplyToDatasetResults: '多个筛选条件适用于数据聚集结果',
    scopeTheRangeOfTheSearchLocations: '确定搜索仓库范围',
    deliveryReport: '派送',
    
    productItemReport: '货物产品报告',
    salesOrderReport: '销售订单报告',
    salesOrderItemReport: '销售订单物品报告',
    deliveryOrderReport: '运输订单报告',
    deliveryOrderItemReport: '运输订单物品报告',
    itemReceiveReport: '货物接收报告',
    itemReceiveItemReport: '货物接收物品报告',
    itemTransferReport: '货物转移报告',
    itemTransferItemReport: '货物转移物品报告',
    stockValueReport: '货物价值报告',
    
    basicSearch: '基础搜索',
    filterDataForBasicInformation: '筛选数据以获取基础信息',
    advancedFilter: '高级筛选',
    filterDataForAdvancedInformation: '筛选数据以获取详细信息',

    // --------MUI--------
    createDateFrom: '创建日期(从)',
    createDateTo: '创建日期(至)',
    profileName: '档案名称',
    deliveryProfileName: '配送档案名称',
    billingProfileName: '账单档案名称',
    supplierProfileName: '供应商档案名称',
    resetFilter: '重置筛选',

    any: '任何',
    documentStatus: '文件状态',
    applyFilters: '应用筛选',
    approval: '批准',

};